import React, { useEffect, useState } from 'react';
import { Button, Icon } from '..';
import './grid.scss';
var sort = {
    asc: 'Asc',
    desc: 'Desc',
};
export var Grid = function (_a) {
    var rowData = _a.rowData, columns = _a.columns, selectFunction = _a.selectFunction, selectRow = _a.selectRow, gotoPage = _a.gotoPage, pageSize = _a.pageSize, maxPage = _a.maxPage, sortRows = _a.sortRows, pinned = _a.pinned, noRowsMessage = _a.noRowsMessage, extendClass = _a.extendClass, disablePaging = _a.disablePaging, showHeaders = _a.showHeaders, defaultSortColumn = _a.defaultSortColumn, defaultDirection = _a.defaultDirection, isFilterValueChanged = _a.isFilterValueChanged, setIsFilterValueChanged = _a.setIsFilterValueChanged, _b = _a.activeRow, _activeRow = _b === void 0 ? 0 : _b;
    var _c = useState([]), displayData = _c[0], setDisplayData = _c[1];
    var _d = useState(1), pageNumber = _d[0], setPageNumber = _d[1];
    var _e = useState(1), currentPageNumber = _e[0], setCurrentPageNumber = _e[1];
    var _f = useState(_activeRow), activeRow = _f[0], setActiveRow = _f[1];
    var _g = useState(1), pageLimit = _g[0], setPageLimit = _g[1];
    var _h = useState({ id: undefined, direction: ' ' }), sortColumn = _h[0], setSortColumn = _h[1];
    useEffect(function () {
        // because of asynchronous nature isFilterValueChanged is not changing immediatly, so we are using useEffect
    }, [isFilterValueChanged]);
    var gridClasses = 'c-grid';
    if (pinned) {
        gridClasses += " sticky-".concat(pinned);
    }
    if (extendClass) {
        gridClasses += " ".concat(extendClass);
    }
    var paging = function (increment) {
        var pNum = pageNumber + increment;
        pNum = pNum < 1 ? 1 : pNum > pageLimit ? pageNumber : pNum;
        fetchData(rowData, pNum);
    };
    var fetchData = function (data, pagePosition) {
        var nextPage = pagePosition || pageNumber;
        if (pageSize == undefined && gotoPage == undefined)
            setDisplayData(data);
        else if (gotoPage !== undefined) {
            gotoPage(nextPage, pageSize).then(function (result) {
                setDisplayData(result);
            });
        }
        else {
            pageData(data, nextPage);
        }
        setCurrentPageNumber(nextPage);
        setPageNumber(nextPage);
    };
    var pageData = function (data, pageNumber) {
        var _a;
        if (pageSize == undefined) {
            setDisplayData(data);
        }
        else {
            var pagePosition = pageNumber * pageSize;
            setDisplayData((_a = data === null || data === void 0 ? void 0 : data.slice(pagePosition - pageSize, pagePosition)) !== null && _a !== void 0 ? _a : []);
            if ((data === null || data === void 0 ? void 0 : data.length) > 0 && isFilterValueChanged) {
                setPageNumber(1);
                setCurrentPageNumber(1);
            }
        }
        if ((data === null || data === void 0 ? void 0 : data.length) > 0 && data[0].pageCount < currentPageNumber) {
            setPageNumber(1);
            setCurrentPageNumber(1);
        }
        if (setIsFilterValueChanged != undefined)
            setIsFilterValueChanged(false);
    };
    var sorting = function (e, column) {
        var _a, _b;
        var targetColumn = {
            id: column.id,
            direction: sortColumn.id === column.id ? sortColumn.direction : sort.desc,
        };
        if (sortColumn.direction == sort.desc) {
            targetColumn.id = undefined;
            targetColumn.direction = undefined;
        }
        else {
            targetColumn.direction = targetColumn.direction === sort.asc ? sort.desc : sort.asc;
        }
        setSortColumn(targetColumn);
        if (sortRows !== undefined) {
            var sortedColumn = targetColumn.id == undefined ? (_a = columns === null || columns === void 0 ? void 0 : columns.find(function (col) { return col.id == defaultSortColumn; })) !== null && _a !== void 0 ? _a : column : column;
            sortRows(sortedColumn, (_b = targetColumn.direction) !== null && _b !== void 0 ? _b : defaultDirection).then(function (result) {
                setPageNumber(1);
                pageData(result, 1);
            });
        }
        else {
            fetchData(rowData);
        }
    };
    useEffect(function () {
        pageData(rowData, 1);
        setPageLimit(maxPage || Math.ceil((rowData === null || rowData === void 0 ? void 0 : rowData.length) / pageSize || 1 / pageSize));
    }, [rowData]);
    useEffect(function () {
        setPageLimit(maxPage);
    }, [maxPage]);
    useEffect(function () {
        setActiveRow(_activeRow);
    }, [_activeRow]);
    useEffect(function () {
        if (selectFunction !== undefined)
            columns.push({
                id: 'Select',
                description: 'Select',
                sort: false,
                filter: false,
                render: function (column, row) {
                    return (React.createElement(Button, { type: "button", variant: "primary", onClick: selectFunction, dataValue: row.id }, 'Select'));
                },
            });
    }, [columns]);
    var firstPage = function () {
        fetchData(rowData, 1);
    };
    var nextPage = function () {
        paging(1);
    };
    var prevPage = function () {
        paging(-1);
    };
    var lastPage = function () {
        fetchData(rowData, pageLimit);
    };
    var selectRowEvent = function (e, row, rowIndex) {
        if (selectRow) {
            setActiveRow(rowIndex);
            selectRow(row);
        }
    };
    return (React.createElement("div", { className: "c-overflow" },
        React.createElement("table", { className: gridClasses },
            React.createElement("thead", null,
                React.createElement("tr", null, columns
                    .filter(function (col) { var _a; return !((_a = col.hidden) !== null && _a !== void 0 ? _a : false); })
                    .map(function (column) {
                    var _a, _b, _c, _d;
                    return column.renderHead !== undefined ? (column.renderHead(column)) : (React.createElement("th", { colSpan: (_a = column === null || column === void 0 ? void 0 : column.span) !== null && _a !== void 0 ? _a : 1, key: "header-".concat(column === null || column === void 0 ? void 0 : column.id), className: (_b = column === null || column === void 0 ? void 0 : column.extendClass) !== null && _b !== void 0 ? _b : '', hidden: !(showHeaders !== null && showHeaders !== void 0 ? showHeaders : true) }, (column === null || column === void 0 ? void 0 : column.sort) == false ? ((_c = column === null || column === void 0 ? void 0 : column.description) !== null && _c !== void 0 ? _c : '') : (React.createElement("button", { onClick: function (e) { return sorting(e, column); } }, (_d = column === null || column === void 0 ? void 0 : column.description) !== null && _d !== void 0 ? _d : '',
                        sortColumn.id === (column === null || column === void 0 ? void 0 : column.id) ? (sortColumn.direction === sort.asc ? (React.createElement(Icon, { name: "chevronDown" })) : sortColumn.direction === sort.desc ? (React.createElement(Icon, { name: "chevronUp" })) : null) : null))));
                }))),
            React.createElement("tbody", null, rowData && rowData.length > 0 ? (displayData.map(function (row, rowIndex) { return (React.createElement("tr", { key: "row-".concat(rowIndex), onClick: function (e) { return (selectRow ? selectRowEvent(e, row, rowIndex) : undefined); }, className: selectRow ? (rowIndex == activeRow && !Number.isNaN(_activeRow) ? 'active' : undefined) : undefined }, columns
                .filter(function (col) { var _a; return !((_a = col === null || col === void 0 ? void 0 : col.hidden) !== null && _a !== void 0 ? _a : false); })
                .map(function (column) {
                var _a, _b;
                return (React.createElement("td", { key: "row-".concat(rowIndex, "-").concat(column === null || column === void 0 ? void 0 : column.id), colSpan: (_a = column === null || column === void 0 ? void 0 : column.span) !== null && _a !== void 0 ? _a : 1, className: (_b = column === null || column === void 0 ? void 0 : column.extendClass) !== null && _b !== void 0 ? _b : '' }, column.render !== undefined ? column.render(column, row) : row[column.id]));
            }))); })) : (React.createElement("tr", { className: "c-grid__no-data" },
                React.createElement("td", { className: "c-grid__textcenter", colSpan: columns.length }, noRowsMessage || 'No rows available')))),
            disablePaging !== true && rowData && rowData.length > 0 && (gotoPage || pageSize) && (React.createElement("tfoot", null,
                React.createElement("tr", null,
                    React.createElement("td", { colSpan: columns.length },
                        React.createElement("ul", { className: "c-grid__pagination" },
                            React.createElement("li", null,
                                React.createElement("button", { onClick: firstPage, title: "Go to first page" },
                                    React.createElement("span", null, "Go to first page"),
                                    React.createElement(Icon, { name: "doubleChevronLeft" }))),
                            React.createElement("li", null,
                                React.createElement("button", { onClick: prevPage, title: "Go to previous page" },
                                    React.createElement("span", null, "Go to previous page"),
                                    React.createElement(Icon, { name: "chevronLeft" }))),
                            React.createElement("li", { className: "c-grid__pagination-count" },
                                React.createElement("p", null,
                                    React.createElement("span", null, pageNumber),
                                    React.createElement("span", { className: "u-fs-1" }, "of"),
                                    React.createElement("span", null, pageLimit))),
                            React.createElement("li", null,
                                React.createElement("button", { onClick: nextPage, title: "Go to next page" },
                                    React.createElement("span", null, "Go to next page"),
                                    React.createElement(Icon, { name: "chevronRight" }))),
                            React.createElement("li", null,
                                React.createElement("button", { onClick: lastPage, title: "Go to last page" },
                                    React.createElement("span", null, "Go to last page"),
                                    React.createElement(Icon, { name: "doubleChevronRight" })))))))))));
};
